import { listRestaurants } from "../graphql/customQueries";
import {
  updateMenu,
  createMenuSetting,
  deleteMenu,
  createMenu,
  createRestaurant,
  updateRestaurant,
} from "../graphql/mutations";
import {
  getMenu as getMenuQuery,
  getRestaurant as getRestaurantQuery,
} from "../graphql/queries";
import { createDefaultMenuSetting } from "../actions/Settings";
import { API, graphqlOperation } from "aws-amplify";
import XLSX from "xlsx";
import { Auth } from "aws-amplify";
import {
  MENUS_LOADED,
  MENUS_LOADED_ERROR,
  USER_GROUP_SELECTED,
  RESTAURANTS_LOADED,
  NO_RESTAURANTS_ADDED,
  CHANGE_TAB,
  RESTAURANTS_LOADED_ERROR,
  GET_MENU_DETAIL,
  RESET_USER_GROUP_SELECTED,
} from "./ActionTypes";
import { DEFAULT_SELECTION } from "../constants";

export const getMenuById = (id) => async (dispatch) => {
  try {
    const { data } = await API.graphql(graphqlOperation(getMenuQuery, { id }));
    if (data && data.getMenu) {
      dispatch({
        type: GET_MENU_DETAIL,
        payload: data.getMenu,
      });
      return;
    }

    throw new Error("Can not find menu!");
  } catch (err) {
    throw new Error(`Error when get menu: ${err.errors[0].message}`);
  }
};

export const getMenus = (id) => async (dispatch) => {
  try {
    const { data } = await API.graphql(
      graphqlOperation(getRestaurantQuery, { id })
    );
    const restaurant = data.getRestaurant;

    if (restaurant) {
      const menus =
        restaurant.menus && restaurant.menus.items
          ? restaurant.menus.items
          : [];
      const menusPosition = restaurant.menusPosition || [];

      // Sort the menus base on the "menusPosition"
      const sortMenus =
        menusPosition.length > 1
          ? menusPosition
              .map((menuId) => {
                const menu = menus.find((m) => m.id === menuId);
                return menu ? menu : null;
              })
              .filter((menu) => menu !== null)
          : menus;

      dispatch({
        type: MENUS_LOADED,
        payload: sortMenus,
        menusPosition,
      });

      return;
    }

    dispatch({
      type: MENUS_LOADED_ERROR,
      payload: "Can not find restaurant!",
    });
    throw new Error("Can not find restaurant!");
  } catch (err) {
    dispatch({
      type: MENUS_LOADED_ERROR,
      payload: err.errors[0].message,
    });
    throw new Error(`Error get menus: ${err.errors[0].message}`);
  }
};

export const getRestaurant = (groupName) => async (dispatch) => {
  try {
    const { data } = await API.graphql(
      graphqlOperation(listRestaurants, { groupName })
    );

    const restaurantsByGroupName = data && data.restaurantsByGroupName;
    const restaurants = restaurantsByGroupName
      ? restaurantsByGroupName.items
      : [];

    // Get first restaurant on list restaurant at this phase
    if (restaurants.length) {
      dispatch({
        type: RESTAURANTS_LOADED,
        payload: restaurants[0],
      });

      return restaurants[0];
    }
    const defaultRestaurant = createDefaultRestaurant();
    dispatch({
      type: NO_RESTAURANTS_ADDED,
      payload: defaultRestaurant,
    });

    return defaultRestaurant;
  } catch (err) {
    dispatch({
      type: RESTAURANTS_LOADED_ERROR,
      payload: err.errors[0].message,
    });
    throw new Error(`Error get restaurant: ${err.errors[0].message}`);
  }
};

export const selectBusiness = (business) => (dispatch) => {
  dispatch({
    type: USER_GROUP_SELECTED,
    payload: business,
  });
};

export const resetBusiness = () => (dispatch) => {
  dispatch({
    type: RESET_USER_GROUP_SELECTED,
  });
};

export const createNewMenu = async ({
  menuRestaurantId,
  name,
  displayDate,
  displayLogo,
  introduction,
  displayCurrencySymbol,
  menuSetting,
  isPublished,
  fileLocation,
  menuLayout,
}) => {
  try {
    // Create menu settings, using default config
    const defaultMenuSetting = createDefaultMenuSetting();
    const { data } = await API.graphql(
      graphqlOperation(createMenuSetting, {
        input: {
          ...defaultMenuSetting,
          ...menuSetting,
          displayDate,
          displayLogo,
          displayCurrencySymbol,
        },
      })
    );

    // Create new menu
    const createdMenu = await API.graphql(
      graphqlOperation(createMenu, {
        input: {
          name,
          menuRestaurantId,
          menuMenuSettingId: data.createMenuSetting.id,
          description: introduction,
          isPublished,
          fileLocation,
          menuLayout,
        },
      })
    );

    return createdMenu.data.createMenu;
  } catch (error) {
    throw new Error(error);
  }
};

export const deleteMenuItem = async (id) => {
  try {
    // Delete the menu here
    const { data } = await API.graphql(
      graphqlOperation(deleteMenu, { input: { id } })
    );

    // Get data of restaurant after delete
    const restaurant = data.deleteMenu.restaurant;

    // Update "menusPosition" after delete menu success
    // Get the menusPosition fallback to empty array
    const menusPosition = restaurant.menusPosition || [];
    const updateMenusPosition = menusPosition.filter((menuId) => menuId !== id);

    // Update the restaurant after menu delete success
    const updatedRestaurant = await API.graphql(
      graphqlOperation(updateRestaurant, {
        input: { id: restaurant.id, menusPosition: updateMenusPosition },
      })
    );

    return {
      deletedMenu: data.deleteMenu,
      updatedRestaurant: updatedRestaurant.data.updateRestaurant,
    };
  } catch (e) {
    throw new Error("Can not delete menu!");
  }
};

export const addMenu = async (
  menu,
  restaurantName,
  menuName,
  menuDescription,
  groupName
) => {
  try {
    //Create restaurant
    const user = await Auth.currentUserInfo();
    const rest = await API.graphql(
      graphqlOperation(createRestaurant, {
        input: {
          name: restaurantName,
          userId: user.id,
          groupName: groupName,
        },
      })
    );
    //Create menu settings, using default config
    var menuSetting = createDefaultMenuSetting();
    const ms = await API.graphql(
      graphqlOperation(createMenuSetting, {
        input: menuSetting,
      })
    );
    //Create menu
    const cm = await API.graphql(
      graphqlOperation(createMenu, {
        input: {
          name: menuName,
          description: menuDescription ? menuDescription : null,
          menuRestaurantId: rest.data.createRestaurant.id,
          menuMenuSettingId: ms.data.createMenuSetting.id,
        },
      })
    );

    //Updating menu updated data
    menu.id = cm.data.createMenu.id;
    menu.restaurant.id = rest.data.createRestaurant.id;
    menuSetting.id = ms.data.createMenuSetting.id;
    menu.menuSetting = menuSetting;
    menu.name = menuName;
    menu.description = menuDescription;
    menu.restaurant.name = restaurantName;
  } catch (err) {
    console.log("error create menu:", err);
  }
};

export const handleUpdateRestaurant = async (restaurantInput) => {
  try {
    const { data } = await API.graphql(
      graphqlOperation(updateRestaurant, { input: restaurantInput })
    );

    return data.updateRestaurant;
  } catch (error) {
    console.log("Error updating restaurant", error);
    throw new Error(
      `Error updating restaurant: ${
        error.errors[0] ? error.errors[0].message || "" : ""
      }`
    );
  }
};

export const handleCreateRestaurant = async ({
  name,
  userId,
  groupName,
  displayCurrencySymbol,
  displayDate,
  displayLogo,
  introduction,
  logoKey,
  backgroundImageKey,
  displayBackground,
  displayLogoInQRCode,
  restaurantName,
  dateText,
  descriptionText,
  zoomDisabled,
}) => {
  try {
    const input = {
      name,
      userId,
      displayDate,
      displayLogo,
      introduction,
      groupName,
      logoKey,
      displayCurrencySymbol,
      backgroundImageKey,
      displayBackground,
      displayLogoInQRCode,
      restaurantName,
      dateText,
      descriptionText,
      menusPosition: [],
      paidMenus: 3,
      paidMenuImages: true,
      paidBookmarks: true,
      zoomDisabled,
    };

    const { data } = await API.graphql(
      graphqlOperation(createRestaurant, { input })
    );

    return data.createRestaurant;
  } catch (error) {
    console.log("Error creating restaurant", error);
    throw new Error(
      `Error creating restaurant: ${
        error.errors[0] ? error.errors[0].message || "" : ""
      }`
    );
  }
};

export const updateMenuAndRestaurant = async (
  menu,
  restaurantName,
  menuName,
  menuDescription
) => {
  try {
    const inputMenu = {
      id: menu.id,
      name: menuName,
      description: menuDescription ? menuDescription : undefined,
    };
    const inputRestaurant = {
      id: menu.restaurant.id,
      name: restaurantName,
    };

    await API.graphql(graphqlOperation(updateMenu, { input: inputMenu }));
    await API.graphql(
      graphqlOperation(updateRestaurant, { input: inputRestaurant })
    );

    //Updating changes to menu in props
    menu.restaurant.name = restaurantName;
    menu.name = menuName;
    menu.description = menuDescription;
  } catch (err) {
    console.log("error updating menu:", err);
  }
};

export const createDefaultRestaurantSetting = () => ({
  restaurantName: {
    font: DEFAULT_SELECTION.font,
    color: DEFAULT_SELECTION.secondaryColor,
    textstyle: [],
    format: "woff",
  },
  dateText: {
    font: DEFAULT_SELECTION.font,
    color: DEFAULT_SELECTION.secondaryColor,
    textstyle: [],
    format: "woff",
  },
  descriptionText: {
    font: DEFAULT_SELECTION.font,
    color: DEFAULT_SELECTION.secondaryColor,
    textstyle: [],
    format: "woff",
  },
});

export const createDefaultRestaurant = () => ({
  displayDate: false,
  displayLogo: false,
  displayCurrencySymbol: true,
  name: "",
  introduction: null,
  id: "",
  userId: "",
  logoKey: null,
  groupName: "",
  displayBackground: false,
  backgroundImageKey: null,
  displayLogoInQRCode: false,
  menus: { items: [] },
  menusPosition: [],
  paidMenuImages: false,
  zoomDisabled: false,
  ...createDefaultRestaurantSetting(),
});

/**
 * Creates a menu with default setting
 */
export const createDefaultMenu = () => {
  return {
    name: "",
    description: "",
    qrCodeImage: "",
    menuUrl: "",
    fileLocation: null,
    fileName: "",
    menuSetting: createDefaultMenuSetting(),
    restaurant: createDefaultRestaurant(),
    menuLayout: "DEFAULT",
  };
};

/**
 * Helper method to get the group that the user belongs to
 */
export const getUserGroup = async () => {
  try {
    const { accessToken } = await Auth.currentSession();
    const cognitoGroups = accessToken.payload["cognito:groups"];
    //Assume one tenant per user at moment
    const group = cognitoGroups[0];

    return group;
  } catch (e) {
    throw e;
  }
};

var HEADERS = {
  HEADER1: { value: 0 },
  HEADER2: { value: 1 },
  HEADER3: { value: 2 },
  HEADER4: { value: 3 },
  NAME: { value: 4 },
  VINTAGE: { value: 5 },
  PRICE: { value: 6 },
  FORMAT: { value: 7 },
  IMAGE_URL: { value: 8 },
  // PRICEUNIT: { value: 8 }
};

function parseRows(excelData) {
  var rows = [];
  for (var j = 1; j < excelData.length; j++) {
    //add the row to the rows array
    var isValidRow = validateRow(excelData[j]);
    if (isValidRow) {
      var row = excelData[j];
      var data = {};
      data.header1 = trimString(row[HEADERS.HEADER1.value]);
      data.header2 = trimString(row[HEADERS.HEADER2.value]);
      data.header3 = trimString(row[HEADERS.HEADER3.value]);
      data.header4 = trimString(row[HEADERS.HEADER4.value]);
      //data.wineType = row[HEADERS.HEADER1.value];
      //data.region = row[HEADERS.HEADER1.value];
      //data.subRegion = row[HEADERS.HEADER1.value];
      //data.grape = row[HEADERS.HEADER1.value];
      data.name = row[HEADERS.NAME.value];
      //data.description = row[HEADERS.HEADER1.value];
      data.vintage =
        "" + (row[HEADERS.VINTAGE.value] ? row[HEADERS.VINTAGE.value] : "");
      data.price = row[HEADERS.PRICE.value];
      data.format = row[HEADERS.FORMAT.value];
      data.imageUrl = row[HEADERS.IMAGE_URL.value];
      //data.priceUnit = row[HEADERS.PRICEUNIT.value];
      rows.push(data);
    }
  }
  return rows;
}

function trimString(value) {
  if (value && (typeof value === "string" || value instanceof String))
    return value.trim();
  else return value;
}

/**
 *
 * @param {event} event
 */
export const parseFileToJson = (file) =>
  new Promise((resolve, reject) => {
    console.log(" uploaded file: parseExcelFileToJson");
    const valError = "File parsing error, no rows found";
    try {
      const name = file.name;
      const lastDot = name.lastIndexOf(".");
      const ext = name.substring(lastDot + 1);

      //CSV files may have character encoding that has issues, hence readAsText from FileReader
      if (ext === "csv") {
        var fileReader = new FileReader();
        fileReader.onloadend = function (e) {
          var oFile = XLSX.read(e.target.result, { type: "string" });
          const wsname = oFile.SheetNames[0];
          const ws = oFile.Sheets[wsname];
          const excelData = XLSX.utils.sheet_to_json(ws, { header: 1 });
          if (!validateFileHeaders(excelData)) reject(valError);
          var rows = parseRows(excelData);
          resolve(rows);
        };
        fileReader.readAsText(file);
      } else if (ext === "xlsx" || ext === "xls") {
        var fileReader2 = new FileReader();
        fileReader2.onloadend = function (e) {
          var bytes = new Uint8Array(e.target.result);
          var oFile = XLSX.read(bytes, { type: "array" });
          const wsname = oFile.SheetNames[0];
          const ws = oFile.Sheets[wsname];
          const excelData = XLSX.utils.sheet_to_json(ws, { header: 1 });
          if (!validateFileHeaders(excelData)) reject(valError);
          var rows = parseRows(excelData);
          resolve(rows);
        };
        fileReader2.readAsArrayBuffer(file);
      } else {
        reject("File type not supported");
      }
    } catch (e) {
      reject(valError);
    }
  });

/**
 * Function: parseJsonToFile
 * Used to parse json object to "xlsx" file
 *
 * @param {fileName}: name of file
 * @param {jsonData}: Json array object
 * @param {blockPropertiesList}: object properties that don't need while parse to .excel/.csv file
 */
export const parseJsonToFile = (fileName, jsonData, blockPropertiesList) => {
  const jsonDataFilter = jsonData.map((data) => {
    blockPropertiesList.forEach((property) => delete data[property]);
    return data;
  });

  const ws = XLSX.utils.json_to_sheet(jsonDataFilter);
  const wb = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, "test");
  const wbout = XLSX.write(wb, { bookType: "xlsx", type: "binary" });

  const s2ab = (data) => {
    const buf = new ArrayBuffer(data.length);
    const view = new Uint8Array(buf);
    for (var i = 0; i < data.length; i++) view[i] = data.charCodeAt(i) & 0xff;
    return buf;
  };

  const file = new File(
    [new Blob([s2ab(wbout)], { type: "application/octet-stream" })],
    fileName || "menu.xlsx"
  );

  return file;
};

export const saveMenu = (values, selectedMenu, userGroup) => async (
  dispatch
) => {
  try {
    if (selectedMenu.id) {
      await updateMenuAndRestaurant(
        selectedMenu,
        values.restaurantName,
        values.menuName,
        values.menuDescription ? values.menuDescription : undefined
      );
    } else {
      await addMenu(
        selectedMenu,
        values.restaurantName,
        values.menuName,
        values.menuDescription,
        userGroup
      );
    }

    dispatch({
      type: CHANGE_TAB,
      payload: "generalSettings",
    });
  } catch (e) {
    console.log("Error saveMenu", e);
  }
};

export const formatMenuData = (rows) => {
  try {
    var topNode = {};
    var topNodeMap = new Map();

    for (var rowNum = 0; rowNum < rows.length; rowNum++) {
      //if row is missing required fields, skip
      try {
        //Retrieve Top Node
        var currentHeader1 = rows[rowNum].header1;
        if (topNodeMap.has(currentHeader1)) {
          topNode = topNodeMap.get(currentHeader1);
        } else {
          topNode = createNode();
          topNode.title = currentHeader1;
          topNode.style = "header1";
          topNodeMap.set(currentHeader1, topNode);
        }

        var currentNode = topNode;
        //do recursive loop times on the title to find the last node that matches
        //TODO: currently ending at column 4 since we have 4 header columns
        var subHeaders = [
          rows[rowNum].header2,
          rows[rowNum].header3,
          rows[rowNum].header4,
        ];
        for (
          var headerColNum = 0;
          headerColNum < subHeaders.length;
          headerColNum++
        ) {
          var columnTitle = subHeaders[headerColNum];
          //find the last node based on title
          if (columnTitle !== undefined) {
            currentNode = findNode(currentNode, columnTitle, headerColNum);
          }
        }

        //add item to current node
        var item = {};
        item.name = rows[rowNum].name;
        item.description = rows[rowNum].description;
        item.vintage = rows[rowNum].vintage;
        item.price = rows[rowNum].price;
        item.format = rows[rowNum].format;
        //item.priceUnit = rows[rowNum].priceUnit;
        currentNode.items.push(item);

        //since topNode's child nodes might be updated, repush into Map
        topNodeMap.delete(topNode.title);
        topNodeMap.set(topNode.title, topNode);
      } catch (e) {
        console.error(e);
        console.log("Row cannot be processed: " + rows[rowNum]);
      }
    }

    //turn Map into proper json
    //we don't want map keys as "propertyKey" in the JSON, hence calling custom parser that just turns Map values into arrays
    var list = [];

    //validate if any wine nodes was created. if not, throw exception
    if (topNodeMap.size < 1) {
      throw new Error("No valid items found");
    }

    list = convertMapToJon(list, topNodeMap);
    return list;
  } catch (e) {
    console.log(e);
    throw new Error("No valid items found");
  }
};

/**
 * Validation of required fields for a given row/item in spreadsheet
 *
 * @param {array of strings} row
 */
function validateRow(row) {
  if (
    row !== undefined &&
    (row[HEADERS.HEADER1.value] === undefined ||
      row[HEADERS.NAME.value] === undefined ||
      row[HEADERS.PRICE.value] === undefined)
  ) {
    return false;
  } else {
    return true;
  }
}

/**
 * Helper method to create a Node section representing a list section
 */
function createNode() {
  var node = {
    title: "",
    style: "",
    section: [],
    childKeys: new Map(),
    items: [],
  };
  return node;
}

/**
 * Helper method to determine Node's style property based on Header column location in spreadsheet
 *
 * @param {number} headerNum
 */
function getHeaderStyle(headerNum) {
  if (headerNum === 0) {
    return "header2";
  } else if (headerNum === 1) {
    return "header3";
  } else if (headerNum === 2) {
    return "header4";
  }
}

/**
 * Recursive function to find nested tree nodes
 * @param {node} currentNode
 * @param {string} title
 * @param {number} headerNum
 */
function findNode(currentNode, title, headerNum) {
  var section;
  if (currentNode.childKeys.has(title)) {
    section = currentNode.childKeys.get(title);
    return section;
  } else {
    section = createNode();
    section.title = title;
    section.style = getHeaderStyle(headerNum);
    currentNode.childKeys.set(title, section);
    return section;
  }
}

/**
 * Custom JSON converter since we have custom Map keys/values data
 * @param {Array} list
 * @param {Map} map
 */
function convertMapToJon(list, map) {
  if (map === undefined) {
    return null;
  }
  map.forEach((value) => {
    var node = {};
    node.title = value.title;
    node.style = value.style;
    if (value.childKeys === undefined || value.childKeys.size === 0) {
      node.items = value.items;
    } else {
      node.section = convertMapToJon(value.items, value.childKeys);
    }
    list.push(node);
  });
  return list;
}

/**
 * Helper method to print out excel records for debugging
 * @param {Array of strings} row
 */

// eslint-disable-next-line
function printLine(row) {
  console.log(
    "HEADER1 : " +
      row.header1 +
      ", HEADER2 : " +
      row.header2 +
      ", HEADER3 : " +
      row.header3 +
      ", HEADER4 : " +
      row.header4 +
      ", WINETYPE : " +
      row.wineType +
      ", REGION : " +
      row.region +
      ", SUBREGION :  " +
      row.subRegion +
      ", GRAPE : " +
      row.grape +
      ", NAME :  " +
      row.name +
      ", DESCRIPTION :  " +
      row.description +
      ", VINTAGE : " +
      row.vintage +
      ", PRICE :  " +
      row.price +
      ", FORMAT :  " +
      row.format
  );
  //+ ", PRICEUNIT :  " + row.priceUnit);
}

/**
 * Validates that imported file contains proper headers.
 * @param {*} rows
 */
function validateFileHeaders(rows) {
  var row = rows[0];
  try {
    return (
      trimString(row[HEADERS.HEADER1.value]).toLowerCase() === "header1" &&
      trimString(row[HEADERS.HEADER2.value]).toLowerCase() === "header2" &&
      trimString(row[HEADERS.HEADER3.value]).toLowerCase() === "header3" &&
      trimString(row[HEADERS.HEADER4.value]).toLowerCase() === "header4" &&
      trimString(row[HEADERS.NAME.value]).toLowerCase() === "name" &&
      trimString(row[HEADERS.VINTAGE.value]).toLowerCase() === "vintage" &&
      trimString(row[HEADERS.PRICE.value]).toLowerCase() === "price" &&
      trimString(row[HEADERS.FORMAT.value]).toLowerCase() === "format"
    );
  } catch (error) {
    return false;
  }
}
